export let datetimeconstant = {
    sun: [{ start_time: "", end_time: "", uid: "", date: "2023-01-30" }],
    mon: [{ start_time: "", end_time: "", uid: "", date: "2023-01-31" }],
    tue: [{ start_time: "", end_time: "", uid: "", date: "2023-02-01" }],
    wed: [{ start_time: "", end_time: "", uid: "", date: "2023-02-02" }],
    thu: [{ start_time: "", end_time: "", uid: "", date: "2023-02-03" }],
    fri: [{ start_time: "", end_time: "", uid: "", date: "2023-02-04" }],
    sat: [{ start_time: "", end_time: "", uid: "", date: "2023-02-05" }],
  }